import { useMemo, useState } from "react";
const { CloseOutlined } = require("@mui/icons-material");
const { Box, Menu, Button } = require("@mui/material");
const { default: CustomCheckbox } = require("components/Checkbox");

const DashboardFilterMenu = ({
  open,
  options,
  onClose,
  filterType,
  onApply,
  anchorEl,
  optionsDesignation,
  otherAds,
}) => {
  const [selected, setSelected] = useState(options);
  const [selectedDesignation, setSelectedDesignation] = useState(optionsDesignation);
  const [selectedOtherAds, setSelectedOtherAds] = useState(otherAds);

  const isAllSelected = (items, total) => items.length === total && items.every((item) => item.isSelected);

  const isSelectAllChecked = useMemo(() => isAllSelected(selected, options.length), [selected, options.length]);
  const isDesignatedAllChecked = useMemo(() => isAllSelected(selectedDesignation, optionsDesignation.length), [selectedDesignation, optionsDesignation.length]);
  const isOthersAllChecked = useMemo(() => isAllSelected(selectedOtherAds, otherAds.length), [selectedOtherAds, otherAds.length]);

  const toggleSelectAll = (type) => {
    const updateSelection = (items, setItems, total) => {
      const allSelected = isAllSelected(items, total);
      setItems(items.map(item => ({ ...item, isSelected: !allSelected })));
    };

    if (type === "metasearch") {
      updateSelection(selected, setSelected, options.length);
    } else if (type === "otherAds") {
      updateSelection(selectedOtherAds, setSelectedOtherAds, otherAds.length);
    } else if (type === "DesignationAds") {
      updateSelection(selectedDesignation, setSelectedDesignation, optionsDesignation.length);
    }
  };

  const renderItemList = (items, setItems) =>
    items?.map((item) => (
      <li
        key={item.id}
        style={{
          borderLeft: "1px solid #CADEDD",
          paddingLeft: "10px",
          paddingBlock: "5px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
          <Box sx={{ width: "100%", display: "flex", justifyContent: "flex-start" }}>
            <span style={{ flex: "0 0 50%", textAlign: "right", marginRight: "16px" }}>
              <CustomCheckbox
                size="small"
                checked={item.isSelected}
                title={item.label}
                labelStyles={{
                  color: "#000",
                  fontFamily: "Inter",
                  fontSize: "12px",
                  fontStyle: "normal",
                  fontWeight: 400,
                  lineHeight: "normal",
                }}
                onChange={() =>
                  setItems(
                    items.map((i) =>
                      i.id === item.id ? { ...i, isSelected: !i.isSelected } : i
                    )
                  )
                }
              />
            </span>
          </Box>
        </div>
      </li>
    ));

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      sx={{
        width: "100%",
        "& .MuiPaper-root": { borderRadius: "10px" },
      }}
    >
      <div style={{ paddingInline: "10px" }}>
        <div
          style={{
            color: "var(--Grey, #C4C4C4)",
            fontFamily: "Inter",
            fontSize: "10px",
            fontWeight: 400,
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <span>{filterType}</span>
          <span onClick={onClose}>
            <CloseOutlined
              sx={{
                fontSize: "16px",
                cursor: "pointer",
                "&:hover": { color: "black" },
              }}
            />
          </span>
        </div>

        <div style={{ display: "flex" }}>
          <ul
            style={{
              listStyleType: "none",
              marginBlock: 0,
              padding: 0,
              paddingLeft: "4px",
              overflow: "auto",
            }}
          >
            <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
              <span>
                <CustomCheckbox
                  size="small"
                  onChange={() => toggleSelectAll("metasearch")}
                  checked={isSelectAllChecked}
                  title="Metasearch"
                  labelStyles={{
                    color: "#c4c4c4",
                    fontFamily: "Inter",
                    fontSize: "10px",
                    fontWeight: 400,
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                />
              </span>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                width: "100%",
                gap: "5px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  flex: 1,
                  marginLeft: "5px",
                }}
              >
                {renderItemList(selected, setSelected)}
              </Box>
            </Box>
          </ul>

          <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
            <ul>
              <Box sx={{ flex: 1, display: "flex" }}>
                <CustomCheckbox
                  size="small"
                  title="Destination Ads"
                  onChange={() => toggleSelectAll("DesignationAds")}
                  checked={isDesignatedAllChecked}
                  labelStyles={{
                    color: "gray",
                    fontFamily: "Inter",
                    fontSize: "10px",
                    fontWeight: 400,
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                />
              </Box>
              <Box sx={{ display: "flex", flexDirection: "column", marginLeft: "5px" }}>
                {renderItemList(selectedDesignation, setSelectedDesignation)}
              </Box>
            </ul>

            <ul>
              <Box sx={{ flex: 1, display: "flex" }}>
                <CustomCheckbox
                  size="small"
                  title="Other Ads"
                  onChange={() => toggleSelectAll("otherAds")}
                  checked={isOthersAllChecked}
                  labelStyles={{
                    color: "gray",
                    fontFamily: "Inter",
                    fontSize: "10px",
                    fontWeight: 400,
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                />
              </Box>
              <Box sx={{ display: "flex", flexDirection: "column", marginLeft: "5px" }}>
                {renderItemList(selectedOtherAds, setSelectedOtherAds)}
              </Box>
            </ul>
          </div>
        </div>
      </div>

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "14px",
          paddingBlock: "8px",
        }}
      >
        <span
          style={{
            flex: "0 0 50%",
            marginRight: "16px",
            fontSize: "10px",
            cursor: "pointer",
          }}
          className="sublabel"
          onClick={() => {
            setSelected(selected.map((item) => ({ ...item, isSelected: false })));
            setSelectedDesignation(selectedDesignation.map((item) => ({ ...item, isSelected: false })));
            setSelectedOtherAds(selectedOtherAds.map((item) => ({ ...item, isSelected: false })));
          }}
        >
          Unselect All
        </span>
        <Button
          variant="outlined"
          sx={{
            color: "black",
            backgroundColor: "#61D5A9",
            borderRadius: "20px",
            fontSize: "10px",
            width: "100px",
            paddingInline: "8px",
            fontFamily: "inter",
            height: "20px",
          }}
          onClick={() => {
            onApply([
              ...selected.filter((item) => item.isSelected),
              ...selectedDesignation.filter((item) => item.isSelected),
              ...selectedOtherAds.filter((item) => item.isSelected),
            ]);
            onClose();
          }}
        >
          Apply
        </Button>
      </Box>
    </Menu>
  );
};

export default DashboardFilterMenu;
